import React from 'react';
import { mapConsentDescriptionToLabel } from '@tenant/lib/consentHelper';

export interface ConsentDTO {
  code: string;
  description: string;
  id: number;
  mandatory: boolean;
  order: number;
  statuteUrl: string; // link to statue -> pin inside description in the future
}

export interface ConsentDataItem {
  id: number | string;
  mandatory: boolean;
  label: React.ReactNode | string;
}

export interface ConsentParams {
  isChecked: boolean;
  processBusinessConsentId: number;
}

export const mapToConsentItem = (data: ConsentDTO): ConsentDataItem => ({
  ...data,
  label: mapConsentDescriptionToLabel(data.description, data.statuteUrl),
});
